function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.97132 4.88088C8.36188 4.49035 8.99508 4.49041 9.38558 4.88099L11.1189 6.61469C11.5093 7.00524 11.5093 7.63837 11.1187 8.02885L4.77347 14.3735C4.58594 14.561 4.3316 14.6663 4.0664 14.6663H2.33325C1.78097 14.6663 1.33325 14.2186 1.33325 13.6663V11.9325C1.33325 11.6673 1.43862 11.4129 1.62618 11.2254L7.97132 4.88088ZM10.4346 3.83159C10.0441 3.44113 10.044 2.80809 10.4344 2.41754L11.3013 1.55024C11.4404 1.41115 11.6291 1.33301 11.8258 1.33301C12.0226 1.33301 12.2113 1.41115 12.3504 1.55024L14.4494 3.6492C14.5884 3.78834 14.6666 3.97702 14.6666 4.17376C14.6666 4.37049 14.5884 4.55918 14.4494 4.69831L13.5821 5.5652C13.1915 5.95557 12.5585 5.9555 12.168 5.56504L10.4346 3.83159Z",
  fill: "#008A94"
});

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.878f512c.svg";
export { ForwardRef as ReactComponent };